import axios from 'axios';

// handle the the axios ui notifications that will send the
// messages to the notifier vuex store
// then the notification will be catched by the AppSnackbar component
// This module expect a config.hooks which has the callback functions for the
// notifications
const requestHandler = config => {
    // axios.interceptors.request.use(config => {
    if (
        config.hasOwnProperty('notifyRequestPending') &&
        config.notifyRequestPending === true
    ) {
        config.hooks.requestPendingFn();
    } else {
        // if we don't need to notify UI about request pending,
        // then we need to resetNotification at least
        config.hooks.requestStartFn();
    }
    return config;
};

// axios.interceptors.response.use(
const successHandler = response => {
    if (
        response.config.hasOwnProperty('notifySuccess') &&
        response.config.notifySuccess === true
    ) {
        if (response.config.successMessage) {
            response.config.hooks.responseSuccessFn(
                response.config.successMessage
            );
        } else {
            response.config.hooks.responseSuccessFn(
                `http request ${response.config.url} has been submitted successfully`
            );
        }
    }
    if (
        response.config.hasOwnProperty('notifyRequestPending') &&
        response.config.notifyRequestPending === true
    ) {
        response.config.hooks.requestCompleteFn();
    }
    return response;
};

const errorHandler = error => {
    // catch the 401 errors
    if (error.response.status === 401) {
        error.config.hooks.responseUnauthorizedFn();
    }
    if (
        error.config.hasOwnProperty('notifyRequestPending') &&
        error.config.notifyRequestPending === true
    ) {
        error.config.hooks.requestCompleteFn();
    }
    if (
        error.config.hasOwnProperty('notifyError') &&
        error.config.notifyError === false
    ) {
        return Promise.reject(error);
    }

    if (error.config.errorMessage) {
        error.config.hooks.responseErrorFn(error.config.errorMessage);
    } else if (error.response) {
        error.config.hooks.responseErrorFn(error.response.data.message);
    } else {
        error.config.hooks.responseErrorFn(
            'http request faild due to some network errors!'
        );
    }
};

axios.interceptors.request.use(request => requestHandler(request));

axios.interceptors.response.use(
    response => successHandler(response),
    error => errorHandler(error)
);
